import {jwtDecode} from 'jwt-decode';

let forge = require('node-forge');
const EXP_GRACE_SECONDS = 15 * 60;


export const checkLogin = () => {
    const token = localStorage.getItem('token'); // veya başka bir kaynaktan
    if (token) {
        const username = localStorage.getItem('username');
        const decoded = jwtDecode(token);

        const currentTime = Math.floor(Date.now() / 1000);
        if (decoded.exp && currentTime >= (decoded.exp + EXP_GRACE_SECONDS)) {
            return false;
        }

        if (decoded.loginname === username || decoded.sub === username) {
            return true;
        }
    }
    return false;
}

export const checkRegister = (email, username, token) => {
    localStorage.setItem('token', token);
    localStorage.setItem('username', username);
    localStorage.setItem('email', email);
    return true;
}

export const clearRegister = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('username');
    localStorage.removeItem('email');
}

export function encryptDataWithPublicKey(publicKey, data) {
    if (data === null || data === undefined) return data;
    if (publicKey == null) return data;
    let publics = forge.pki.publicKeyFromPem("-----BEGIN PUBLIC KEY-----\n" + publicKey + "-----END PUBLIC KEY-----");
    let encrypted = publics.encrypt(data, "RSA-OAEP", {
        md: forge.md.sha1.create(),
        mgf1: forge.mgf.mgf1.create()
    });
    return forge.util.encode64(encrypted);
}
